import { createI18n } from 'vue-i18n';

const messages = {
  es: {
    login: {
      titulo: "Viscosim",
      subtitulo: "Introduce tus credenciales",
      usuario: "Usuario",
      password: "Contraseña",      
      boton_entrar: "Entrar",
    },
    home:{
      inicio:"Inicio",
      simulaciones:"Simulaciones",
      nueva_sim:"Nueva simulación",
      historico_sim:"Histórico simulaciones",
      descargadores:"Descargadores",
      precios:"Precios",
      futuro:"Futuros",
      informes:"Informes",
      maestros: "Maestros",
      ro: "Ro"      
    },

    maestros: {
      ro: {
        titulo: "Serie temporal de Ro",
        valor: "Valor",
        guardando: "Guardando...",
        cancelar: "Cancelar",
        guardar: "Guardar",
        nuevo: "Nuevo",
        actualizar: "Actualizar",
        editar: "Editar",
        borrar: "Borrar",
        mensajes: {
          borrar_valor: "Esta acción borrará el valor de "
        },
        tabla: {
          fecha: "Fecha", 
          valor: "Valor Ro", 
          usuario_mod: "Usuario modificador", 
          fecha_mod: "Fecha modificación",
          acciones: "Acciones",
        }
      },
    },


    general:{
      importar: "Importar Datos",
      exportar: "Exportar Datos",
      lanzar: "Lanzar simulación",
      guardar: "Guardar",
      descargar_input: "Descargar fichero input",
      nueva_simulacion: "Nueva simulación", 
      simulacion_existente: "Simulación: ", 
      nombre_simulacion: "Nombre",
      descargar:"Descargar", 
      activar_sim:"Activar simulación",
      sim:"Simulaciones",
      activa:"Simulación Activa"
    },

    mensajes:{
      se_produjo_un_problema: "¡Se produjo un problema!",
      precios_omie_no_disponible: "Los precios de OMIE no están disponibles",
      precios_mibgas_no_disponible: "Los precios de MIBGAS no están disponibles",
      precios_simulart_no_disponible: "Los precios de SimularT no están disponibles",
      "estas_seguro": "¿Estás seguro?",
      "borrar_simulacion": "Esto borrará la simulación: ",
      "borrar_simulacion_ok_titulo":"¡Simulación borrada!",
      "borrar_simulacion_ok_subtitulo":"La simulación ha sido borrada correctamente.",
      "borrar_simulacion_nok":"Hubo un problema borrando la simulación", 
      explicacion_botones:"Copia de seguridad de los datos de entrada. Se procederá a la descarga de un archivo *.vis que podrá ser importado para crear nuevas simulaciones a partir del mismo de forma rápida sin necesidad de modificar los parámetros del Caso base.",          
      explicacion_ro:"<strong>¿Configurando valores de Ro?</strong><br>Lo habitual es gestionarlos desde el Maestro de Ro, donde se define la configuración por defecto.<br>Usa el flujo de importación de esta pantalla solo si necesitas cargar excepciones o casos puntuales.<br>Consejo: sigue la vía estándar siempre que sea posible.",
      revisar_disponibilidad:"Revisar la disponibilidad de motores",
      revisar_disponibilidad_ac:"Incoherencia tiempo de acoplamiento mínimo.",
      revisar_disponibilidad_p:"Incoherencia tiempo de parada mínimo.",
      "cambiar_nombre_simulacion": "Esto cambiará el nombre de la simulación.",
     
    },
    comun:{
      boton_ok: "OK",
      boton_cancelar: "Cancelar",
    },

    validation: {
      required: "Este campo es obligatorio",
      debe_ser_numero: "Debe de ser un número",
    },

    tabs: {
      generales:"generales",
      configuracion: "Configuración",
      otros: "Otros datos",
    
      planta: "Planta",
      planta_calderas_electricas: "Calderas Eléctricas",
      planta_motores_cogeneracion: "Motores de Cogeneración",
      planta_calderas_gas: "Calderas de Vapor",
      planta_compresor: "Compresores",
    
      electricidad: "Electricidad",
      electricidad_peajes: "Parámetros CTTO. Eléctrico",
      electricidad_precios_omie: "Precios OMIE",
      electricidad_precios_prevision: "Previsión de Precios",
      electricidad_precios_manual: "Precios Manuales",
      electricidad_swap:"Parámetros Swap eléctrico",
      swap:{
        cantidad:"Cantidad (MWh/día)", 
        precio:"Precio (EUR/MWh)"
      },
      electricidad_precios_historicos:"Precios históricos",
      electricidad_prevision_planificacion:"Previsión de precios",

      gas: "Gas",
      gas_precios_mibgas: "Precios MIBGAS",
      gas_precios_manual: "Precios Manuales",
      gas_precio_titulo:"Precio gas (€/MWh)",
      gas_parametros:"Parámetros CTTO. Gas",
      gas_swap:"Parámetros Swap gas",  
      gas_precios_historicos: "Precios históricos",
      gas_prevision_planificacion:" Previsión de precios",
      ro_cogeneracion: "RO",

      demanda: "Demanda",
      demanda_frio: "Demanda de Frío",
      demanda_vapor: "Demanda de Vapor",
    
      disponibilidad: "Disponibilidad",
      disponibilidad_cogeneracion: "Disponibilidad cogeneración",
      disponibilidad_calderas_gas: "Disponibilidad caldera gas",
      disponibilidad_calderas_electricas: "Disponibilidad calderas eléctricas",
      
      acoplamiento: "Acoplamiento",

      resultados: "Resultados",
      resultados_prevision_operarios: "Previsión operarios",
      resultados_oper: "Operación",
      resultados_econ: "Económicos",
      backup:"Backup",
    },
    info:{
      demanda:{
        p1:"Los archivos de entrada deben ser .csv",
        p2:"Hay dos opciones de formato de archivos de entrada:",
        p3:"- Ficheros que tengan las columnas: 'Date', 'Prediccion' y 'Version' para actualizar vapor",
        p4:"- Ficheros con las columnas: 'Horizonte', 'Demanda de frío (MW)' y 'Demanda de vapor (MW)' para actualizar frío y vapor",
        p5:"Los ficheros exportados lo hacen en este último formato.",
      },
    },
    "configuracion": {
      "titulo": "Configuración",
      "fecha_actual": "Fecha actual",
      "horizonte_dias": "Horizonte (días)",
      "precios": "Precios",
      "modo_ejecucion": "Modo de ejecución",
      "mes_backtesting": "Mes backtesting",
      "alerta_backtesting": "Se ha lanzado una actualización de precios automática, ya que el modo backtesting ha sido seleccionado.",
      "mes_planificacion": "Mes planificación",
      "opciones_precios": {
        "omie": "OMIE",
        "simulart": "SimularT",
        "manual": "Manual"
      },
      "opciones_modo_ejecucion": {
        "optimizacion": "Optimización",
        "sin_parar_cogeneracion": "Sin parar cogeneración",
        "acoplamientos_fijados": "Acoplamientos de cogeneración fijados",
        "backtesting": "Backtesting",
        "planificacion": "Planificación"
      },
    },
    otros: {
      titulo: "Otros datos",
      precios: "Precios",
      precio_CO2: "Precio CO2",
      eur_tonelada: "EUR/ton",
      precio_electricidad_cerrado: "Precio de electricidad cerrado",
      potencia_precio_electricidad_cerrado:"Potencia que va a precio de electricidad cerrado",
      impuesto_generacion: "Impuesto generación",
      eur_mwh: "EUR/MWh",
      mwh: "MWh",
      otros:"Otros",
      banda_sec:"Banda secundaria",
      min_tec:"Mínimo técnico",
      cantidad_min: "Banda",
      cantidad_max:"Cantidad máxima",
      oferta:"Coste operativo",


    },
    electricidad:{
      horizonte:"Horizonte",
      hora:"Hora",
      periodo:"Periodo",
      peajes_title:"Peajes de electricidad",
      precios_omie: "Precios OMIE",
      precio_omie_fmt:"Precio casación OMIE (€/MWh)",
      precios_historicos_omie: "Precios históricos de OMIE",
      precios_prevision:"Previsión de precio",
      prevision_precio_fmt:"Previsión precio (€/MWh)",
      pot_contratada:"Pot. contratada (MWe)",
      pcio_exceso_potencia:"Precio exceso de potencia (€/h)",
      pot_contratada_calderas:"Pot.contratada calderas eléctricas (MWe)",
      pot_peaje:"Peaje pot. (EUR/kWe)",
      ai_omie:"Ai OMIE (abierto)",
      bi_omie:"Bi OMIE (abierto)",
      ai_fijo:"Ai fijo (cerrado)",
      bi_fijo:"Bi fijo (cerrado)",
      precio_mercado:"Precio mercado (€/MWh)",
      fecha_hora: "Fecha Hora",
      pot_elec_precio_cerrado:"Pot. a precio de electricidad cerrado (MW)",
      precio_estimado:"Precio Estimado (€ / MWh)"
      
    },
    gas:{
      horizonte:"Horizonte",
      hora:"Hora",
      precios_historicos_mibgas: "Precios históricos de MIBGAS",
      fecha_hora: "Fecha Hora",
      precio_mibgas_fmt: "Precio casación MIBGAS (€/MWh)",
      impuesto:"Impuesto gas (EUR/MWht)",
      fnee:"FNEE (EUR/MWht)",
      term_a:"Término A (EUR/MWht)",
      term_bmc:"Término Bmc",
      term_bcg:"Término Bcg",
      peaje:"Peaje fijo gas (EUR/h)",
      input_prov:"Input provisional de gas (EUR/MWht)",
      label_switch_input:"Utilizar input provisional de gas",
      campo:"Campo",
      valor:"Valor",
      precio_estimado:"Precio Estimado (€ / MWh)",
      Qd:"Qd contratada (MWh)"
    },
    ro_cogeneracion: {
      titulo: "Ro mensual",
      horizonte: "Horizonte",
      cogeneracion: "Cogeneración",
      motor: "Motor cogeneración",
      valor_motores:"Valor motores (EUR/MWhe)"
    },

    demanda:{
      horizonte:"Horizonte",
      hora:"Hora",
      vapor:"Demanda de vapor (MW)",
      frio:"Demanda de frío (MW)",
      coeficiente: "Coeficiente de demanda",
    },
    planta: {
      planta_calderas_electricas: "Calderas Eléctricas",
        calderas_electricas: {
          potencia_electrica_maxima: "Potencia eléctrica máxima (MWe)",
          potencia_electrica_minima: "Potencia eléctrica mínima (MWe)",
          potencia_vapor_maximo: "Potencia de vapor máxima (MWt)",
          rendimiento_vapor_electricidad: "Rendimiento vapor/electricidad (p.u)",
          estado_inicial_equipo: "Estado inicial equipo (Parado/Encendido)",

        },
         calderas_electricas_corto: {
          potencia_electrica_maxima: "Pot. eléc. máx. (MWe)",
          potencia_electrica_minima: "Pot. eléc. mín. (MWe)",
          potencia_vapor_maximo: "Pot. vapor máx. (MWt)",
          rendimiento_vapor_electricidad: "Rend. vapor/elec. (p.u)",
          estado_inicial_equipo: "Estado inicial",

        },

      planta_motores_cogeneracion: "Motores de Cogeneración",
        motores_cogeneracion: {
          potencia_maxima: "Potencia máxima (MWe)",
          potencia_minima: "Potencia mínima (MWe)",
          potencia_exportacion: "Potencia exportación (MWe)",
          rendimiento_vapor_gas: "Rendimiento vapor/gas (p.u.)",
          rendimiento_electricidad_gas: "Rendimiento electricidad/gas (p.u.)",
          porcentaje_agua_caliente: "% para agua caliente (%)",
          rendimiento_agua_fria_agua_caliente: "Rendimiento agua fría/agua caliente (p.u.)",
          coeficiente_emisiones_CO2: "Coeficiente emisiones CO2 (tonCO2/MWhe)",
          tiempo_arranque: "Tiempo de arranque (min)",
          tiempo_parada: "Tiempo de parada (min)",
          estado_inicial: "Estado inicial equipo (Parado/Encendido)",
          fee: "Fee (EUR/MWhe)",
          tiempo_minimo_acoplamiento: "Tiempo mínimo acoplamiento (h)",
          tiempo_minimo_parada: "Tiempo mínimo de parada (h)",
        },

        motores_cogeneracion_corto:{
              "potencia_maxima": "Pot. máx. (MWe)",
              "potencia_minima": "Pot. mín. (MWe)",
              "potencia_exportacion": "Pot. export. (MWe)",
              "rendimiento_vapor_gas": "Rend. vapor/gas",
              "rendimiento_electricidad_gas": "Rend. elec./gas",
              "porcentaje_agua_caliente": "% AC",
              "rendimiento_agua_fria_agua_caliente": "Rend. AF/AC",
              "coeficiente_emisiones_CO2": "Coef. emis. CO2",
              "tiempo_arranque": "Tiempo de arranque (min)",
              "tiempo_parada": "Tiempo de parada (min)",
              "estado_inicial": "Estado inicial",
              "fee": "Fee",
              "tiempo_minimo_acoplamiento": "Tiempo mín. acopla. (h)",
              "tiempo_minimo_parada": "Tiempo mín. parada (h)"
        },
        planta_calderas_gas: "Calderas de gas",
         calderas_gas: {
          potencia_gas_maxima: "Potencia de gas máxima (MWt)",
          potencia_gas_minima: "Potencia de gas mínima (MWt)",
          potencia_vapor_maxima: "Potencia de vapor máxima (MWt)",
          rendimiento_vapor_gas: "Rendimiento vapor/gas (p.u)",
          coeficiente_emisiones_CO2: "Coeficientes emisiones CO2 (tonCO2/MWt)",
          estado_inicial_equipo: "Estado inicial equipo (Parado/Encendido)",
        },
         calderas_gas_corto: {
          potencia_gas_maxima: "Pot. gas máx. (MWt)",
          potencia_gas_minima: "Pot. gas mín. (MWt)",
          potencia_vapor_maxima: "Pot. vapor máx. (MWt)",
          rendimiento_vapor_gas: "Rend. vapor/gas (p.u)",
          coeficiente_emisiones_CO2: "Coef. emis. CO2 (tonCO2/MWt)",
          estado_inicial_equipo: "Estado inicial",
        },
        planta_compresores:"Compresores",
         compresores: {
          potencia_maxima: "Potencia Máxima (kWe)",
          potencia_minima: "Potencia Mínima (kWe)",
          rendimiento_frio_electricidad: "Rendimiento frío/electricidad(p.u)",
          estado_inicial_equipo: "Estado inicial equipo(Parado/Encendido)",
          coste_alquiler: "Coste alquiler (EUR/día)",
          coste_uso: "Coste por uso (EUR/h)",
         } ,
         compresores_corto: {
          potencia_maxima: "Pot. Máx. (kWe)",
          potencia_minima: "Pot. Mín. (kWe)",
          rendimiento_frio_electricidad: "Rend. frío/elec",
          estado_inicial_equipo: "Estado inicial",
          coste_alquiler: "Alquiler (EUR/día)",
          coste_uso: "Uso (EUR/h)",
         }       
    
    },
    disponibilidad: {
      disponibilidad_calderas_electricas: "Calderas Eléctricas",
        calderas_electricas: {
        horizonte: "Horizonte",
        hora: "Hora",
        },
      disponibilidad_calderas_gas: "Calderas de Gas",
        calderas_gas: {
        horizonte: "Horizonte",
        hora: "Hora",
        },
      disponibilidad_cogeneracion: "Cogeneración",
        cogeneracion: {
        horizonte: "Horizonte",
        hora: "Hora",
        }

    },  

    acoplamiento_equipos: {
      acoplamiento_cogeneracion: "Cogeneración",
      no:"No",
      si:"Sí",
      hora:"Hora",
        cogeneracion: {
          horizonte: "Horizonte",
          acoplado: "¿Acoplado?",
        }
    },
    simulaciones: {
      titulo: "Listado de simulaciones históricas",
      boton_actualizar:"Actualizar",
      filtrar:"Filtrar",
      ordenar:"Ordenar",
      cerrar:"Cerrar",
      advertencia:"Advertencia",
      busqueda:"Buscar por Nombre, Usuario, Fecha",
      descargando: "Descargando simulaciones",
      error_multiples: "Hay más de una simulación activa para las siguientes fechas:<br>{fechas}",
      error_ninguna: "No hay simulación activa para las siguientes fechas:<br>{fechas}",
      obteniendo_programa: "Obteniendo programa para {id}",
      obteniendo_resultados: "Obteniendo resultados para  {id}",
      error_otras_activas: "Hay otras simulaciones activas para este día {fecha}",
      error_ninguna_activa: "No hay otras simulaciones activas para esta fecha: {fecha}",
      actualizando:"Actualizando estado",
      error_sim_duplicada:"¡Ya existe una simulación activa para esta fecha!<br>No debería haber más de una simulación válida para el día {fecha}.",
      error_sim_valida:"Debería haber al menos una simulación válida para el día {fecha}.",
      tabla: {
        nombre: "Nombre",
        usuario: "Usuario",
        fecha: "Creación",
        START_DATE_SIMULATION: "Fecha de aplicación",
        HORIZON: "Horizonte",
        estado: "Estado",
        valida: "Válida",
        acciones: "Acciones",
      },
      boton: {
        nueva: "Crear",
        ver_resultado: "Ver resultado",
        borrar_simulacion: "Borrar",
      },
      estados: {
        creada: "Creada",
        guardada: "Guardada",
        en_ejecucion: "En ejecución...",
        ejecutada_ok: "Ejecutada OK",
        ejecutada_nok: "Ejecutada NOK",
        cancelada: "Cancelada",
        borrada: "Borrada",
      }
    },  
    resultados: {
      nominacion:"Subir nominación",
      mail_nom:"Mail nominación",
      mail_planificacion:"Mail planificación",
      imprimir:"Imprimir página",
      descargar_excel:"Descargar como excel",
      descargar_excel_completo:"Descargar excel completo",
      descargar_excel_oferta_secundaria:"Descargar excel oferta secundaria",
      descargar_excel_intradiario:"Descargar excel de oferta de mercado intradiario",
      motor:"Motor",
      calderas:"Calderas eléctricas",
      consumo_gas_total:"Consumo total de gas",
      precio_pool:"Precio pool referencia motores de cogeneración",
      precio_pool_ce:"Precio pool referencia calderas eléctricas",
      economicos:"Resultados económicos",
      operativos:"Resultados de operación"
    }
  }, 
  en: {
    login: {
      titulo: "Viscosim",
      subtitulo: "Enter your credentials",
      usuario: "User",
      password: "Password",
      boton_entrar: "Login",
    },
    home: {
      inicio: "Home",
      simulaciones: "Simulations",
      nueva_sim: "New Simulation",
      historico_sim: "Simulation history",
      descargadores: "Downloaders",
      precios: "Prices",
      futuro: "Futures",
      informes: "Reports",
      maestros: "Masters",
      ro: "Ro"
    },

    maestros: {
      ro: {
        titulo: "Ro Time Series",
        valor: "Value",
        guardando: "Saving...",
        cancelar: "Cancel",
        guardar: "Save",
        nuevo: "New",
        actualizar: "Update",
        editar: "Edit",
        borrar: "Delete",
        mensajes: {
          borrar_valor: "This action will delete the value of "
        },
        tabla: {
          fecha: "Date", 
          valor: "Ro Value", 
          usuario_mod: "Modifying User", 
          fecha_mod: "Modification Date",
          acciones: "Actions",
        }
      },
    },
    


    general: {
      importar: "Import Data",
      exportar: "Export Data",
      lanzar: "Launch simulation",
      guardar: "Save",
      descargar_input: "Download input file",
      nueva_simulacion: "New simulation",
      simulacion_existente: "Simulation: ",
      nombre_simulacion: "Name",
      descargar: "Download",
      activar_sim: "Activate simulation",
      sim: "Simulations",
      activa: "Active simulation"
    },

    mensajes: {
      se_produjo_un_problema: "A problem occurred!",
      precios_omie_no_disponible: "OMIE prices are not available",
      precios_mibgas_no_disponible: "MIBGAS prices are not available",
      precios_simulart_no_disponible: "SimularT prices are not available",
      estas_seguro: "Are you sure?",
      borrar_simulacion: "This will delete the simulation: ",
      borrar_simulacion_ok_titulo: "Simulation deleted!",
      borrar_simulacion_ok_subtitulo: "The simulation has been successfully deleted.",
      borrar_simulacion_nok: "There was a problem deleting the simulation",
      explicacion_botones:"Backup of input data. A *.vis file will be downloaded, which can be imported to quickly create new simulations from it without having to modify the parameters of the base case.",
      explicacion_ro:"<strong>Setting Ro values</strong><br>These are usually managed in the <i>Ro Master</i>, where the default configuration is defined.<br>Use this screen only if you need to import exceptions or handle specific cases.<br><strong>Tip</strong>: stick to the standard process whenever possible.",
      revisar_disponibilidad:"Check engine availability: Inconsistency in minimum coupling/stop time.",
      cambiar_nombre_simulacion: "This will change the name of the simulation.",
     
    },

    comun: {
      boton_ok: "OK",
      boton_cancelar: "Cancel",
    },

    validation: {
      required: "This field is required",
      debe_ser_numero: "Must be a number",
    },

    tabs: {
      generales: "General",
      configuracion: "Configuration",
      otros: "Other data",

      planta: "Plant",
      planta_calderas_electricas: "Electric boilers",
      planta_motores_cogeneracion: "Cogeneration engines",
      planta_calderas_gas: "Steam boilers",
      planta_compresor: "Compressors",

      electricidad: "Electricity",
      electricidad_peajes: "Electric tolls",
      electricidad_precios_omie: "OMIE prices",
      electricidad_precios_prevision: "Price forecast",
      electricidad_precios_manual: "Manual prices",
      electricidad_swap: "Electric swap parameters",
      swap: {
        cantidad: "Quantity (MWh/day)",
        precio: "Price (EUR/MWh)"
      },
      electricidad_precios_historicos: "Historical prices",
      electricidad_prevision_planificacion: "Price forecast",

      gas: "Gas",
      gas_precios_mibgas: "MIBGAS prices",
      gas_precios_manual: "Manual prices",
      gas_precio_titulo: "Gas price (€/MWh)",
      gas_parametros: "Parameters",
      gas_swap: "Gas swap parameters",
      gas_precios_historicos: "Historical prices",
      gas_prevision_planificacion: "Price forecast",
      ro_cogeneracion: "RO",

      demanda: "Demand",
      demanda_frio: "Cooling demand",
      demanda_vapor: "Steam demand",

      disponibilidad: "Availability",
      disponibilidad_cogeneracion: "Cogeneration availability",
      disponibilidad_calderas_gas: "Gas boiler availability",
      disponibilidad_calderas_electricas: "Electric boiler availability",

      acoplamiento: "Coupling",

      resultados: "Results",
      resultados_prevision_operarios: "Operator forecast",
      resultados_oper: "Operation",
      resultados_econ: "Economic",
      backup:"Backup",
    },

    info: {
      demanda: {
        p1: "Input files must be .csv",
        p2: "There are two input file format options:",
        p3: "- Files with columns: 'Date', 'Prediction' and 'Version' to update steam",
        p4: "- Files with columns: 'Horizon', 'Cooling Demand (MW)' and 'Steam Demand (MW)' to update cooling and steam",
        p5: "Exported files follow the latter format."
      }
    },

    configuracion: {
      titulo: "Configuration",
      fecha_actual: "Current date",
      horizonte_dias: "Horizon (days)",
      precios: "Prices",
      modo_ejecucion: "Execution mode",
      mes_backtesting: "Backtesting month",
      alerta_backtesting: "An automatic price update has been launched, as the backtesting mode was selected.",
      mes_planificacion: "Planning month",
      opciones_precios: {
        omie: "OMIE",
        simulart: "SimularT",
        manual: "Manual"
      },
      opciones_modo_ejecucion: {
        optimizacion: "Optimization",
        sin_parar_cogeneracion: "Without stopping cogeneration",
        acoplamientos_fijados: "Fixed cogeneration couplings",
        backtesting: "Backtesting",
        planificacion: "Planning"
      }
    },

    otros: {
      titulo: "Other data",
      precios: "Prices",
      precio_CO2: "CO2 Price",
      eur_tonelada: "EUR/ton",
      precio_electricidad_cerrado: "Closed electricity price",
      potencia_precio_electricidad_cerrado: "Power at closed electricity price",
      impuesto_generacion: "Generation tax",
      eur_mwh: "EUR/MWh",
      mwh: "MWh",
      otros: "Others",
      banda_sec:"Secondary band",
      min_tec: "Technical minimum",
      cantidad_min: "Minimum quantity",
      cantidad_max: "Maximum quantity",
      oferta: "Operating cost",

    },
     electricidad: {
      horizonte:"Horizon",
      hora:"Hour",
      periodo:"Period",
      peajes_title: "Electricity tolls",
      precios_omie: "OMIE prices",
      precio_omie_fmt: "OMIE clearing price (€/MWh)",
      precios_historicos_omie: "Historical OMIE prices",
      precios_prevision: "Price forecast",
      prevision_precio_fmt: "Forecast price (€/MWh)",
      pot_contratada: "Contracted power (MWe)",
      pcio_exceso_potencia: "Excess power price (EUR/MWh)",
      pot_contratada_calderas: "Contracted power electric boilers (MWe)",
      pot_peaje: "Toll power (EUR/kWe)",
      ai_omie: "Ai OMIE (open)",
      bi_omie: "Bi OMIE (open)",
      ai_fijo: "Ai fixed (closed)",
      bi_fijo: "Bi fixed (closed)",
      precio_mercado: "Market price (€/MWh)",
      fecha_hora: "Date time",
      pot_elec_precio_cerrado: "Power at closed electricity price (MW)",
      precio_estimado: "Estimated Price (€ / MWh)"
    },

    gas: {
      horizonte:"Horizon",
      hora:"Hour",
      precios_historicos_mibgas: "Historical MIBGAS prices",
      fecha_hora: "Date time",
      precio_mibgas_fmt: "MIBGAS clearing price (€/MWh)",
      impuesto: "Gas tax (EUR/MWht)",
      fnee: "FNEE (EUR/MWht)",
      term_a: "Term A (EUR/MWht)",
      term_bmc: "Term Bmc",
      term_bcg: "Term Bcg",
      peaje: "Fixed gas toll (EUR/h)",
      input_prov:" Provisional gas input (EUR/MWht)",
      label_switch_input:"Use provisional gas input",
      campo: "Field",
      valor: "Value",
      precio_estimado: "Estimated Price (€ / MWh)",
      Qd:"Contracted Qd (MWh)"
    },

    ro_cogeneracion: {
      titulo: "Monthly RO",
      horizonte: "Horizon",
      cogeneracion: "Cogeneration",
      motor: "Cogeneration engine",
      valor_motores: "Engines Value (EUR/MWhe)"
    },

    demanda: {
      horizonte:"Horizon",
      hora:"Hour",
      vapor: "Steam demand (MW)",
      frio: "Cooling demand (MW)",
      coeficiente: "Demand coefficient"
    },

    planta: {
      planta_calderas_electricas: "Electric boilers",
      calderas_electricas: {
        potencia_electrica_maxima: "Maximum electric power (MWe)",
        potencia_electrica_minima: "Minimum electric power (MWe)",
        potencia_vapor_maximo: "Maximum steam power (MWt)",
        rendimiento_vapor_electricidad: "Steam/Electricity efficiency (p.u)",
        estado_inicial_equipo: "Initial equipment status (Off/On)"
      },
      calderas_electricas_corto: {
        potencia_electrica_maxima: "Max Elec. power (MWe)",
        potencia_electrica_minima: "Min Elec. power (MWe)",
        potencia_vapor_maximo: "Max steam power (MWt)",
        rendimiento_vapor_electricidad: "Steam/Elec. Eff. (p.u)",
        estado_inicial_equipo: "Initial status"
      },

      planta_motores_cogeneracion: "Cogeneration engines",
      motores_cogeneracion: {
        potencia_maxima: "Maximum power (MWe)",
        potencia_minima: "Minimum power (MWe)",
        potencia_exportacion: "Export power (MWe)",
        rendimiento_vapor_gas: "Steam/Gas efficiency (p.u.)",
        rendimiento_electricidad_gas: "Electricity/Gas efficiency (p.u.)",
        porcentaje_agua_caliente: "% for hot water (%)",
        rendimiento_agua_fria_agua_caliente: "Cold/Hot water efficiency (p.u.)",
        coeficiente_emisiones_CO2: "CO2 emissions coefficient (tonCO2/MWhe)",
        tiempo_arranque: "Start time (min)",
        tiempo_parada: "Stop time (min)",
        estado_inicial: "Initial equipment status (Off/On)",
        fee: "Fee (EUR/MWhe)",
        tiempo_minimo_acoplamiento: "Min coupling time (h)",
        tiempo_minimo_parada: "Min stop time (h)"
      },
      motores_cogeneracion_corto: {
        potencia_maxima: "Max power (MWe)",
        potencia_minima: "Min power (MWe)",
        potencia_exportacion: "Export power (MWe)",
        rendimiento_vapor_gas: "Steam/Gas Eff.",
        rendimiento_electricidad_gas: "Elec./Gas Eff.",
        porcentaje_agua_caliente: "% HW",
        rendimiento_agua_fria_agua_caliente: "CW/HW Eff.",
        coeficiente_emisiones_CO2: "CO2 Emiss. Coeff.",
        tiempo_arranque: "Start time (min)",
        tiempo_parada: "Stop time (min)",
        estado_inicial: "Initial status",
        fee: "Fee",
        tiempo_minimo_acoplamiento: "Min coupling (h)",
        tiempo_minimo_parada: "Min stop (h)"
      },
      planta_calderas_gas: "Gas boilers",
      calderas_gas: {
        potencia_gas_maxima: "Max gas power (MWt)",
        potencia_gas_minima: "Min gas power (MWt)",
        potencia_vapor_maxima: "Max steam power (MWt)",
        rendimiento_vapor_gas: "Steam/Gas efficiency (p.u)",
        coeficiente_emisiones_CO2: "CO2 emissions coefficient (tonCO2/MWt)",
        estado_inicial_equipo: "Initial equipment status (Off/On)"
      },
      calderas_gas_corto: {
        potencia_gas_maxima: "Max gas (MWt)",
        potencia_gas_minima: "Min gas (MWt)",
        potencia_vapor_maxima: "Max steam (MWt)",
        rendimiento_vapor_gas: "Steam/Gas Eff. (p.u)",
        coeficiente_emisiones_CO2: "CO2 Emiss. Coeff. (tonCO2/MWt)",
        estado_inicial_equipo: "Initial status"
      },
      planta_compresores: "Compressors",
      compresores: {
        potencia_maxima: "Maximum power (kWe)",
        potencia_minima: "Minimum power (kWe)",
        rendimiento_frio_electricidad: "Cooling/Electricity efficiency (p.u)",
        estado_inicial_equipo: "Initial equipment status (Off/On)",
        coste_alquiler: "Rental cost (EUR/day)",
        coste_uso: "Usage cost (EUR/h)"
      },
      compresores_corto: {
        potencia_maxima: "Max power (kWe)",
        potencia_minima: "Min power (kWe)",
        rendimiento_frio_electricidad: "Cooling/Elec. Eff.",
        estado_inicial_equipo: "Initial status",
        coste_alquiler: "Rental (EUR/day)",
        coste_uso: "Usage (EUR/h)"
      }
    },

    disponibilidad: {
      disponibilidad_calderas_electricas: "Electric boilers",
      calderas_electricas: {
        horizonte: "Horizon",
        hora: "Hour"
      },
      disponibilidad_calderas_gas: "Gas boilers",
      calderas_gas: {
        horizonte: "Horizon",
        hora: "Hour"
      },
      disponibilidad_cogeneracion: "Cogeneration",
      cogeneracion: {
        horizonte: "Horizon",
        hora: "Hour"
      }
    },

    acoplamiento_equipos: {
      acoplamiento_cogeneracion: "Cogeneration",
      no:"No",
      si:"Yes",
      hora:"Hour",
      cogeneracion: {
        horizonte: "Horizon",
        acoplado: "Coupled?"
      }
    },

    simulaciones: {
      titulo: "Historical simulations list",
      boton_actualizar: "Update",
      filtrar: "Filter",
      ordenar: "Sort",
      cerrar: "Close",
      advertencia: "Warning",
      busqueda: "Search by Name, User, Date",
      descargando: "Downloading simulations",
      error_multiples: "There is more than one active simulation for the following dates:<br>{fechas}",
      error_ninguna: "There is no active simulation for the following dates:<br>{fechas}",
      obteniendo_programa: "Getting schedule for {id}",
      obteniendo_resultados: "Getting results for {id}",
      error_otras_activas: "There are other active simulations for this day {fecha}",
      error_ninguna_activa: "There are no other active simulations for this date: {fecha}",
      actualizando:"Updating status",
      error_sim_duplicada:"There is already an active simulation for this date!<br>There should not be more than one valid simulation for the day {fecha}.",      
      error_sim_valida:"There should be at least one valid simulation for the day {fecha}.",
      tabla: {
        nombre: "Name",
        usuario: "User",
        fecha: "Creation",
        START_DATE_SIMULATION: "Application",
        HORIZON: "Horizon",
        estado: "Status",
        valida: "Valid",
        acciones: "Actions"
      },
      boton: {
        nueva: "Create",
        ver_resultado: "View result",
        borrar_simulacion: "Delete"
      },
      estados: {
        creada: "Created",
        guardada: "Saved",
        en_ejecucion: "Running...",
        ejecutada_ok: "Executed OK",
        ejecutada_nok: "Executed NOK",
        cancelada: "Cancelled",
        borrada: "Deleted"
      }
    },
    resultados: {
      nominacion: "Upload nomination",
      mail_nom: "Nomination email",
      mail_planificacion: "Planning email",
      imprimir: "Print page",
      descargar_excel: "Download as Excel",
      descargar_excel_completo: "Download full Excel",
      descargar_excel_oferta_secundaria:"Download Excel file for secondary offer",
      descargar_excel_intradiario:"Download intraday market offer excel",
      motor: "Engine",
      calderas: "Electric boilers",
      consumo_gas_total: "Total gas consumption",
      precio_pool: "Reference pool price for cogeneration engines",
      precio_pool_ce: "Reference pool price for electric boilers",
      economicos:"Economic results",
      operativos:"Operation results"
    }
  

    
  },
};




const i18n = createI18n({
  locale: 'es', // Idioma por defecto
  fallbackLocale: 'es', // Idioma de respaldo
  messages,
});

export default i18n;
